<template>
    <div>
                <PageBanner :pageTitle="$t('sidebar_implants_r3_title')" />

        <ImplantsQuality/>
    </div>
</template>

<script>

import ImplantsQuality from '../blog-details/ImplantsQuality.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
       PageBanner,
        ImplantsQuality ,
    }
}
</script>